import { createIcon } from "@excalidraw/excalidraw/components/icons";
import { MainMenu } from "@excalidraw/excalidraw/index";
import React from "react";

import type { Theme } from "@excalidraw/element/types";

const newCanvasInNewTabIcon = createIcon(
  <path
    fill="#820000"
    fillRule="nonzero"
    d="M15.67,5.352l-2.643,2.644l2.643,2.643l-5.022,-0l-0,5.031l-2.644,-2.643l-2.643,2.643l0,-5.031l-5.031,-0l2.643,-2.643l-2.643,-2.644l5.031,0l0,-5.022l2.643,2.643l2.644,-2.643l-0,5.022l5.022,0Zm-2.123,0.952l-3.78,-0l-0,-3.78l-1.763,1.762l-1.762,-1.762l0,3.78l-3.789,-0l1.763,1.762l-1.763,1.762l3.789,0l0,3.789l1.762,-1.762l1.763,1.762l-0,-3.789l3.78,0l-1.763,-1.762l1.763,-1.762Z"
  />,
  { width: 16, height: 16 },
);

import { LanguageList } from "../app-language/LanguageList";

export const AppMainMenu: React.FC<{
  onCollabDialogOpen: () => any;
  isCollaborating: boolean;
  isCollabEnabled: boolean;
  theme: Theme | "system";
  setTheme: (theme: Theme | "system") => void;
  refresh: () => void;
}> = React.memo((props) => {
  return (
    <MainMenu>
      <MainMenu.Item
        icon={newCanvasInNewTabIcon}
        onSelect={() => {
          const bytes = new Uint8Array(6);
          crypto.getRandomValues(bytes);
          const id = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
          window.open(
            `${window.location.origin}${window.location.pathname}?canvas=${id}`,
            "_blank",
          );
        }}
      >
        New Canvas
      </MainMenu.Item>
      <MainMenu.DefaultItems.LoadScene />
      <MainMenu.DefaultItems.SaveToActiveFile />
      <MainMenu.DefaultItems.Export />
      <MainMenu.DefaultItems.SaveAsImage />
      {props.isCollabEnabled && (
        <MainMenu.DefaultItems.LiveCollaborationTrigger
          isCollaborating={props.isCollaborating}
          onSelect={() => props.onCollabDialogOpen()}
        />
      )}
      <MainMenu.DefaultItems.SearchMenu />
      <MainMenu.DefaultItems.Help />
      <MainMenu.DefaultItems.ClearCanvas />
      <MainMenu.Separator />
      <MainMenu.DefaultItems.Preferences />
      <MainMenu.DefaultItems.ToggleTheme
        allowSystemTheme
        theme={props.theme}
        onSelect={props.setTheme}
      />
      <MainMenu.ItemCustom>
        <LanguageList style={{ width: "100%" }} />
      </MainMenu.ItemCustom>
      <MainMenu.DefaultItems.ChangeCanvasBackground />
    </MainMenu>
  );
});
